<template>
  <section class="header" style="margin-top: 8rem;">
    <div class="social-media d-none d-xl-flex" style="margin-top: 2rem;">
      <i class="fa fa-facebook icon"></i>
      <i class="fa fa-instagram icon"></i>
      <i class="fa fa-twitter icon"></i>
      <i class="fa fa-youtube-play icon"></i>
      <img src="../assets/images/registration1/line.png" alt="line"/>
      <img src="../assets/images/registration1/arrow.png" alt="arrow" class="mt-3"/>
      <div class="social-media-title">Profile Company</div>
    </div>

    <div class="container pt-5">
      <div class="text-center mb-3" v-if="loading === true">
        <img src="../assets/images/includes/loading.gif" alt="loading...">
      </div>
      <div v-if="error !== ''" class="alert alert-danger text-center text-uppercase">{{ error }}</div>
      <div v-if="success !== ''" class="alert alert-success text-center text-uppercase">{{ success }}</div>
      <div class="row d-flex align-items-start justify-content-center">
        <div class="col-lg-6 d-none d-xxl-block video-container">
          <img
              alt="video"
              class="video-cover img-fluid"
              src="../assets/images/registration1/video-cover.png"
          />
          <div class="elipse-container">
            <div class="play">
              <!--<img alt="play" class="play-icon"
                   src="../assets/images/registration1/play.png"/>
              <span class="video-title">How to register</span>-->
            </div>
          </div>
        </div>
        <div class="col-lg-6 form">
          <form class="row">
            <div class="form-title mb-5">Businesses Registration Form</div>
            <div class="row mb-5">
              <div class="col-xxl-6 mb-5">
                <label class="label form-label mb-2"
                >First Name<span class="star">*</span></label
                >
                <input
                    type="text"
                    class="form-control"
                    placeholder="First Name"
                    v-model="firstName"
                />
              </div>
              <div class="col-xxl-6">
                <label class="label form-label"
                >Last Name<span class="star">*</span></label
                >
                <input
                    type="text"
                    class="form-control"
                    placeholder="Last Name"
                    v-model="lastName"
                />
              </div>
            </div>
            <div class="col-12 mb-5">
              <label class="label form-label"
              >Email Address<span class="star">*</span></label
              >
              <input
                  type="email"
                  class="form-control"
                  placeholder="Email Address"
                  v-model="email"
              />
            </div>
            <div class="col-12 mb-5">
              <label class="label form-label"
              >Business/Organization Name<span class="star">*</span></label
              >
              <input
                  type="email"
                  class="form-control"
                  placeholder="Business/Organization Name"
                  v-model="businessName"
              />
            </div>
            <div class="col-12 mb-5">
              <label class="label form-label"
              >Website<span class="star">*</span></label
              >
              <input
                  type="email"
                  class="form-control"
                  placeholder="Website"
                  v-model="website"
              />
            </div>
            <div class="col-12 mb-5">
              <label class="label form-label"
              >Address<span class="star">*</span></label
              >
              <input
                  type="email"
                  class="form-control"
                  placeholder="Address"
                  v-model="address"
              />
            </div>
            <div class="col-12 mb-5">
              <label class="label form-label"
              >Your Position<span class="star">*</span></label
              >
              <input
                  type="text"
                  class="form-control"
                  placeholder="Your Position"
                  v-model="position"
              />
            </div>
            <div class="col-12 mb-5">
              <label class="label form-label"
              >Business Interests<span class="star">*</span></label
              >
              <input
                  type="text"
                  class="form-control"
                  placeholder="Business Interests"
                  v-model="interests"
              />
            </div>

          </form>
        </div>
      </div>
    </div>
    <div class="container choices">
      <div class="section-title">What are you looking for ?</div>
      <div class="row cards">
        <div class="col-xl-3 col-lg-6 choice">
          <div class="circle"><span class="number">1</span></div>
          <div class="card h-100" :class="{ 'selected1' : selectedOption === 'Course / Training' }">
            <div class="card-deco1"></div>
            <div class="card-title">Course / Training</div>
            <div class="card-body">
              <div class="card-choice">100+ Courses</div>
              <hr/>
              <div class="card-choice">Live Online Courses</div>
              <hr/>
              <div class="card-choice">Team Study Rooms</div>
              <hr/>
              <div class="card-choice">Certifications</div>
              <hr/>
              <div class="card-choice">Membership Offers</div>
              <hr/>
              <div class="card-choice">
                Notification on latest course & training program
              </div>
              <hr/>
            </div>
            <button class="btn card-button" @click.prevent="selectedOption = 'Course / Training'">choose</button>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 choice">
          <div class="circle"><span class="number">2</span></div>
          <div class="card h-100" :class="{ 'selected2' : selectedOption === 'Project Consultancy' }">
            <div class="card-deco2"></div>
            <div class="card-title">Project Consultancy</div>
            <div class="card-body">
              <div class="card-choice">
                Project consultation of your idea.
              </div>
              <hr/>
              <div class="card-choice">
                Suggestions of innovative project ideas and techniques to
                reach your goals.
              </div>
              <hr/>
              <div class="card-choice">
                Advise, plan, and lead you to final execution
              </div>
              <hr/>
            </div>
            <button class="btn card-button" @click.prevent="selectedOption = 'Project Consultancy'">choose</button>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 choice">
          <div class="circle"><span class="number">3</span></div>
          <div class="card h-100" :class="{ 'selected3' : selectedOption === 'Shopping' }">
            <div class="card-deco3"></div>
            <div class="card-title">Shopping</div>
            <div class="card-body">
              <div class="card-choice">2000+ Products from 15 categories</div>
              <hr/>
              <div class="card-choice">
                Consult our experts of how and why to use curtain products, or
                if it would be the best fit to your project.
              </div>
              <hr/>
              <div class="card-choice">Members Discount Coupons</div>
              <hr/>
              <div class="card-choice">Notification on latest products</div>
              <hr/>
              <div class="card-choice">Membership Offers</div>
              <hr/>
            </div>
            <button class="btn card-button" @click.prevent="selectedOption = 'Shopping'">choose</button>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 choice">
          <div class="circle"><span class="number">4</span></div>
          <div class="card h-100" :class="{ 'selected4' : selectedOption === 'Event' }">
            <div class="card-deco4"></div>
            <div class="card-title">Event</div>
            <div class="card-body">
              <div class="card-choice">
                Join us for our wide range of events : <br/>. Reginal &
                International Competitions<br/>
                . Summer / Winter Camps <br/>. Sports Events <br/>.
                Festivals <br/>. Exhibitions
              </div>
              <hr/>
              <div class="card-choice">Membership offers</div>
              <hr/>
              <div class="card-choice">Volunteering Hours</div>
              <hr/>
            </div>
            <button class="btn card-button" @click.prevent="selectedOption = 'Event'">choose</button>
          </div>
        </div>
        <div class="text-center my-5">
          <button class="free-trial" @click.prevent="save()">GV Learning Free Trial</button>
        </div>
      </div>
    </div>
    <div class="background2 d-none d-xl-block"></div>

    <div class="choices-mobile p-2 mb-5">
      <div class="container">
        <div class="section-title-mobile mb-4">
          What are you looking for ?
        </div>
        <div class="circles">
          <div @click.prevent="selectedOption = 'Course / Training'" class="circle tablink current"
               @click="openTab($event,1)"><span class="number">1</span></div>
          <div @click.prevent="selectedOption = 'Project Consultancy'" class="circle tablink"
               @click="openTab($event,2)"><span class="number">2</span></div>
          <div @click.prevent="selectedOption = 'Shopping'" class="circle tablink" @click="openTab($event,3)"><span
              class="number">3</span></div>
          <div @click.prevent="selectedOption = 'Event'" class="circle tablink" @click="openTab($event,4)"><span
              class="number">4</span></div>
        </div>
        <div class="card mobile-card mx-auto mb-5" id="1" style="display: flex;">
          <div class="card-title">Course / Training</div>
          <div class="card-body">
            <div class="card-choice">100+ Courses</div>
            <hr/>
            <div class="card-choice">Live Online Courses</div>
            <hr/>
            <div class="card-choice">Team Study Rooms</div>
            <hr/>
            <div class="card-choice">Certifications</div>
            <hr/>
            <div class="card-choice">Membership Offers</div>
            <hr/>
            <div class="card-choice">
              Notification on latest course & training program
            </div>
            <hr/>
          </div>
          <button class="btn card-button">choose</button>
        </div>
        <div class="card mobile-card mx-auto mb-5" id="2">
          <div class="card-title">Project Consultancy</div>
          <div class="card-body">
            <div class="card-choice">
              Project consultation of your idea.
            </div>
            <hr/>
            <div class="card-choice">
              Suggestions of innovative project ideas and techniques to
              reach your goals.
            </div>
            <hr/>
            <div class="card-choice">
              Advise, plan, and lead you to final execution
            </div>
            <hr/>
          </div>
          <button class="btn card-button">choose</button>
        </div>
        <div class="card mobile-card mx-auto mb-5" id="3">
          <div class="card-title">Shopping</div>
          <div class="card-body">
            <div class="card-choice">2000+ Products from 15 categories</div>
            <hr/>
            <div class="card-choice">
              Consult our experts of how and why to use curtain products, or
              if it would be the best fit to your project.
            </div>
            <hr/>
            <div class="card-choice">Members Discount Coupons</div>
            <hr/>
            <div class="card-choice">Notification on latest products</div>
            <hr/>
            <div class="card-choice">Membership Offers</div>
            <hr/>
          </div>
          <button class="btn card-button">choose</button>
        </div>
        <div class="card mobile-card  mx-auto mb-5" id="4">

          <div class="card-title">Event</div>
          <div class="card-body">
            <div class="card-choice">
              Join us for our wide range of events : <br/>. Reginal &
              International Competitions<br/>
              . Summer / Winter Camps <br/>. Sports Events <br/>.
              Festivals <br/>. Exhibitions
            </div>
            <hr/>
            <div class="card-choice">Membership offers</div>
            <hr/>
            <div class="card-choice">Volunteering Hours</div>
            <hr/>
          </div>
          <button class="btn card-button">choose</button>
        </div>
      </div>
    </div>

    <div class="footer" style="height: auto; padding: 0;">
      <div class="container text-center">
        <div class="form-check d-flex align-items-center justify-content-center">
          <input type="checkbox" class="me-2" v-model="privacyPolicy">
          <label class="label">I have read, understood, and accepted the PRIVACY POLICY.</label>
        </div>
        <button class="btn-submit" @click.prevent="save">Submit</button>
        <div class="info">Once you submit your application, we will contact you shortly to complete your
          application.
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      firstName: '',
      lastName: '',
      email: '',
      businessName: '',
      website: '',
      address: '',
      position: '',
      interests: '',
      privacyPolicy: false,
      selectedOption: this.isMobile() ? 'Course / Training' : '',
      error: '',
      success: '',
      loading: false,
    }
  },
  methods: {
    openTab(event, id) {
      let i;
      let x = document.getElementsByClassName("mobile-card");
      let tablinks = document.getElementsByClassName("tablink");
      for (i = 0; i < x.length; i++) {
        x[i].style.display = "none";
      }
      for (i = 0; i < x.length; i++) {
        tablinks[i].className = tablinks[i].className.replace(" current", "");
      }
      event.currentTarget.className += " current";
      document.getElementById(id).style.display = "flex";
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    reset() {
      this.firstName = '';
      this.lastName = '';
      this.email = '';
      this.businessName = '';
      this.website = '';
      this.address = '';
      this.position = '';
      this.interests = '';
      this.privacyPolicy = false;
      this.selectedOption = '';
      this.loading = false;
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    async save() {
      this.error = '';
      this.success = '';
      this.loading = true;
      this.scrollToTop();
      if (this.firstName === '') {
        this.error = 'First Name is required';
        this.loading = false;
        return
      }
      if (this.lastName === '') {
        this.error = 'Last Name is required';
        this.loading = false;
        return
      }
      if (this.email === '') {
        this.error = 'Email is required';
        this.loading = false;
        return
      }
      if (this.businessName === '') {
        this.error = 'Business Name is required';
        this.loading = false;
        return
      }
      if (this.website === null) {
        this.error = 'Website is required';
        this.loading = false;
        return
      }
      if (this.address === null) {
        this.error = 'Address is required';
        this.loading = false;
        return
      }
      if (this.position === null) {
        this.error = 'Position is required';
        this.loading = false;
        return
      }
      if (this.interests === null) {
        this.error = 'Interests is required';
        this.loading = false;
        return
      }
      if (this.selectedOption === '') {
        this.error = 'You must select "what are looking for?"';
        this.loading = false;
        return
      }
      if (this.privacyPolicy === false) {
        this.error = 'You must agree the "PRIVACY POLICY"';
        this.loading = false;
        return
      }

      let data = {
        'firstName': this.firstName,
        'lastName': this.lastName,
        'email': this.email,
        'businessName': this.businessName,
        'website': this.website,
        'address': this.address,
        'position': this.position,
        'interests': this.interests,
        'selectedOption': this.selectedOption,
      }

      await axios.post('/api/business-registration', data)
          .then(() => {
            this.success = "Business Registration Form Submitted!"
          })
          .catch(() => {
            this.error = "Please try again later!"
          })
      this.reset();
    }
  },
}
</script>

<style>
@import "../assets/styles/business.css";
</style>
